import { render } from "./2DataPerizinan.vue?vue&type=template&id=24b40f56"
import script from "./2DataPerizinan.vue?vue&type=script&lang=js"
export * from "./2DataPerizinan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__